import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getVerificationStatusLabel, useExpertReportVerificationStatusHistory } from '@/entities/expert-report';
import { HistoryDialog, HistoryEntryByline } from '@/shared/ui';

type Props = {
  conversationId: number;
  expertReportId: number;
};

/**
 * История смен статуса проверки результата заключения: откуда, куда, кто сменил и когда.
 *
 * Открыта каждому, кто видит диалог, — правка статуса тут ни при чём. Смену, сделанную расчётом
 * заключения, никто не делал, поэтому вместо автора у неё назван сам расчёт.
 */
export const ExpertReportVerificationStatusHistory: FC<Props> = ({ conversationId, expertReportId }) => {
  const { t } = useTranslation(['dialogs']);

  return (
    <HistoryDialog
      title={t('dialogs:expertReport.verificationStatusHistory')}
      emptyText={t('dialogs:expertReport.verificationStatusHistoryEmpty')}
      useHistory={useExpertReportVerificationStatusHistory}
      params={{ conversationId, expertReportId }}
      getItemKey={(item) => `${item.changedAt}-${item.status}`}
      renderItem={(item) => (
        <div className="flex flex-col gap-0.5">
          <span>
            {`${getVerificationStatusLabel(t, item.previousStatus)} → ${getVerificationStatusLabel(t, item.status)}`}
          </span>
          <HistoryEntryByline
            authorName={item.authorName}
            defaultAuthorName={t('dialogs:expertReport.verificationStatusChangedByPipeline')}
            date={item.changedAt}
          />
        </div>
      )}
    />
  );
};
